import React, { useContext, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToggleNavContext } from "../../helpers/context";
import { api } from "../../util/urlConfig";
import { GlobalState } from "../../GlobalState";
import "./topbar.css";
import { useEffect } from "react";
import SupplierFeedbackNotifyComponent from "../NotificationComponent/supplierFeedbackNotifyComponent";
import { updateAdminNotification } from "../../action";
import CustomerFeedbackNotifyComponent from "../NotificationComponent/CustomerFeedbackNotifyComponent";
import CustomerAccountNotifyComponent from "../NotificationComponent/CustomerAccountNotifyComponent";
import PurchaseNotifyComponent from "../NotificationComponent/PurchaseNotifyComponent";
import BottleReturnNotifyComponent from "../NotificationComponent/BottleReturnNotifyComponent";
import DamageNotifyComponent from "../NotificationComponent/DamageNotifyComponent";
import InvoiceNotifyComponent from "../NotificationComponent/InvoiceNotifyComponent";
import PromotionNotifyComponent from "../NotificationComponent/PromotionNotifyComponent";
import ProductNotifyComponent from "../NotificationComponent/ProductNotifyComponent";

export default function TopBar() {
  const navigate = useNavigate();
  const { isToggled, setToggle } = useContext(ToggleNavContext);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));
  const [showNotification, setShowNotification] = useState(false);

  const state = useContext(GlobalState);
  const [adminNotifications] = state.notificationAPI.adminNotifications;
  const [adminNotificationCount] = state.notificationAPI.adminNotificationCount;
  const [callback, setCallback] = state.notificationAPI.callback;

  const notificationRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    }

    if (showNotification) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [adminNotifications, adminNotificationCount,showNotification]);

  const notificationTitle = (type) => {
    switch (type) {
      case "supplierFeedback":
        return "Supplier Feedback";
        break;
      case "customerFeedback":
        return "Customer Feedback";
        break;
      case "bottlereturn_create":
        return "Bottle Return";
        break;
      case "bottlereturn_update":
        return "Bottle Return";
        break;
      case "customeraccount_create":
        return "Account";
        break;
      case "customeraccount_update":
        return "Account";
        break;
      case "damage_create":
        return "Damage";
        break;
      case "damage_update":
        return "Damage";
        break;
      case "invoice_create":
        return "Invoice";
        break;
      case "promotion_create":
        return "Promotion";
        break;
      case "purchase_create":
        return "Purchase";
        break;
      case "product_create":
        return "Product";
        break;
      default:
        return "Notification";
        break;
    }
  };

  function NotificationData({ type, id }) {
    switch (type) {
      case "supplierFeedback":
        return <SupplierFeedbackNotifyComponent id={id} />;
        break;
      case "purchase_create":
        return <PurchaseNotifyComponent purchaseId={id} />;
        break;
      case "customerFeedback":
        return <CustomerFeedbackNotifyComponent id={id} />;
        break;
      case "bottlereturn_create":
      case "bottlereturn_update":
        return <BottleReturnNotifyComponent id={id} />;
        break;
      case "customeraccount_create":
      case "customeraccount_update":
        return <CustomerAccountNotifyComponent id={id} />;
        break;
      case "damage_create":
      case "damage_update":
        return <DamageNotifyComponent id={id} />;
        break;
      case "invoice_create":
        return <InvoiceNotifyComponent id={id} />;
        break;
      case "promotion_create":
        return <PromotionNotifyComponent id={id} />;
        break;
      case "product_create":
        return <ProductNotifyComponent productId={id} />;
        break;
      default:
        return (
          <div>
            <p>Nothing...</p>
          </div>
        );
        break;
    }
  }

  const readNotification = (type, id) => {
    updateAdminNotification(id);
    setCallback(!callback);
    setShowNotification(false);

    const routes = {
      supplierFeedback: `/supplier-feedback-form/${id}`,
      customerFeedback: `/customer-feedback-form/${id}`,
      bottlereturn_create: `/bottle-return`,
      bottlereturn_update: `/bottle-return`,
      customeraccount_create: `/customer-account`,
      customeraccount_update: `/customer-account`,
      damage_create: `/damage`,
      damage_update: `/damage`,
      invoice_create: `/invoice-view/${id}`,
      promotion_create: `/promotion`,
      purchase_create: `/purchase-view/${id}`,
      product_create: `/product-view/${id}`,
    };

    if (routes[type]) navigate(routes[type]);
  };

  return (
    <section className={isToggled ? "dashboard-expand" : "dashboard"}>
      <div className="top">
        <i className="uil uil-bars sidebar-toggle" onClick={() => (isToggled ? setToggle(false) : setToggle(true))}></i>
        <div className="search-box">
          <i className="uil uil-search"></i>
          <input type="text" name="search" id="search" placeholder="Search here...." />
        </div>

        <div className="notification-container">
          <div>
            <Link to={`/user-view/${signInUser.id}`}>
              <img src={signInUser.upload_image ? api + "/" + signInUser.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
            </Link>
          </div>

          <div className="notification-icon-container" onClick={() => (showNotification ? setShowNotification(false) : setShowNotification(true))}>
            <i className="uil uil-bell notification-icon">{adminNotificationCount > 0 ? <span className="badge"></span> : <></>}</i>
          </div>
        </div>
      </div>

      {showNotification && (
        <div ref={notificationRef} className="notification-list-container">
          {adminNotifications && adminNotifications.length > 0 ? (
            adminNotifications.map((notify) => (
              <div key={notify.id} className="notification-content-container" onClick={() => readNotification(notify.notifyType, notify.id)}>
                <div className="notification-title">{notificationTitle(notify.notifyType)}</div>
                <NotificationData type={notify.notifyType} id={notify.notifyId} />
              </div>
            ))
          ) : (
            <div>No new notification</div>
          )}
        </div>
      )}
    </section>
  );
}

/*
showNotification ? <div className='notification-list-container'>
                    {
                        adminNotifications ?
                            adminNotifications.map(notify => (
                                <div key={notify.id} className='notification-content-container' onClick={() => readNotification(notify.notifyType, notify.id)}>
                                    <div className='notification-title'>{notificationTitle(notify.notifyType)}</div>
                                    {
                                        <NotificationData type={notify.notifyType} id={notify.notifyId} />
                                    }
                                </div>
                            ))
                            : <></>
                    }
                </div> : null
 */
